var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%, width: 100%" }, attrs: { id: _vm.id } },
    [
      _c(
        "b-modal",
        {
          attrs: {
            size: "lg",
            "footer-class": "footerClass",
            title: "Edit Assigned Staff",
            "no-close-on-backdrop": "",
            "content-class": "shadow",
            scrollable: "",
          },
          on: { hidden: _vm.modalCancel },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function ({ cancel }) {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "success" },
                      on: { click: _vm.ok },
                    },
                    [_vm._v(_vm._s(_vm.$t("button.ok")))]
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: {
                        click: function ($event) {
                          return cancel()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.modalShow,
            callback: function ($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow",
          },
        },
        [
          _c(
            "b-form-group",
            [
              _c("label", { staticClass: "mr-1" }, [
                _vm._v(_vm._s(_vm.$t(`task.field.staffs`))),
              ]),
              _c(
                "button",
                {
                  staticClass: "btn-action",
                  on: { click: _vm.staffSelectorToggle },
                },
                [_c("font-awesome-icon", { attrs: { icon: ["far", "plus"] } })],
                1
              ),
              _c("BadgeGroup", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ item, index }) {
                      return [
                        _c("Badge", {
                          key: index,
                          attrs: {
                            text: _vm.hideUtilization
                              ? item.name
                              : `${item.name} (${
                                  item.unit > 1 ? item.unit + " x " : ""
                                }${Math.trunc(item.utilization * 100)}%)`,
                            variant: item.genericStaff ? "info" : "primary",
                            pillable: !!item.pillable,
                          },
                          on: {
                            badgeRemove: function ($event) {
                              return _vm.staffBadgeRemove(index)
                            },
                            badgeClick: function ($event) {
                              return _vm.staffBadgeClick(item.uuId)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.staffs,
                  callback: function ($$v) {
                    _vm.staffs = $$v
                  },
                  expression: "staffs",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.staffSelectorShow
        ? _c("StaffSelectorModalForAdmin", {
            attrs: {
              show: _vm.staffSelectorShow,
              hideBookings: "",
              companies: _vm.companies,
              taskUuId: _vm.taskUuId,
              nonAdmin: "",
            },
            on: {
              "update:show": function ($event) {
                _vm.staffSelectorShow = $event
              },
              ok: _vm.staffSelectorOk,
              cancel: _vm.staffSelectorCancel,
            },
          })
        : _vm._e(),
      _vm.staffUtilizationEditShow
        ? _c("StaffUtilizationModal", {
            attrs: {
              show: _vm.staffUtilizationEditShow,
              uuId: _vm.staffUtilizationEdit.uuId,
              name: _vm.staffUtilizationEdit.name,
              utilization: _vm.staffUtilizationEdit.utilization,
              unit: _vm.staffUtilizationEdit.unit,
              genericStaff: _vm.staffUtilizationEdit.genericStaff,
            },
            on: {
              "update:show": function ($event) {
                _vm.staffUtilizationEditShow = $event
              },
              ok: _vm.staffUtilizationOk,
            },
          })
        : _vm._e(),
      _vm._l(_vm.toConfirmStaffs, function (item, index) {
        return [
          _c("StaffUtilizationModal", {
            key: `staff-${index}`,
            attrs: {
              show: item.show,
              canApplyAll: _vm.toConfirmStaffs.length > 1,
              uuId: item.uuId,
              name: item.name,
              utilization: item.utilization,
              unit: item.unit,
              genericStaff: item.genericStaff,
            },
            on: {
              "update:show": function ($event) {
                return _vm.$set(item, "show", $event)
              },
              ok: _vm.toConfirmStaffOk,
              cancel: _vm.toConfirmStaffCancel,
            },
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }